<div [formGroup]="this.formGroup">
    <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>{{field.label}}</mat-label>
        <!-- <mat-icon>help</mat-icon> -->
        <input (blur)="onBlurEvent($event)" [mask]="getMask()" matInput placeholder="{{field.label}}" [formControlName]="this.fieldKey" maxlength="{{getMaxLenght()}}">
        <!--<mat-hint>Hint</mat-hint>-->
    </mat-form-field>
</div>
